import AccountData from './AccountData';

export default AccountData;